import { cn } from "@/domains/library"

/**
 * InnerCard is a component that renders a card with a warning border and shadow if the hasWarning prop is true.
 * It is used to wrap the content of a card that can have a warning state.
 */
export const InnerCard = ({ children, hasWarning }: { children: React.ReactNode; hasWarning?: boolean }) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-4",
        "rounded-lg border",
        " bg-p300",
        "px-4 py-4",
        hasWarning ? "border-error-text/50" : "border-p300-light",
        hasWarning ? "shadow-[0_0_4px_0_rgba(255,108,102,0.5)]" : "",
      )}
    >
      {children}
    </div>
  )
}
